import { styled } from '@mui/material';

const Spacer = styled('div')<{ flex?: number }>(({ flex }) => ({
  flex: `${flex ?? 1} 1 auto`,
}));

export default Spacer;
